import { copy } from "../../../data/copy";

function About() {
  const { title: aboutTitle, subtitle: aboutSubtitle, description: aboutDescription } = copy.about;
  const { bio: staffBio, name: staffName, role: staffRole } = copy.staff;

  return (
    <section
      id="about"
      className="relative bg-transparent pt-28 pb-16 sm:pt-36 sm:pb-20 md:pt-44 md:pb-24 lg:pt-52 lg:pb-28 xl:pt-56 xl:pb-32 2xl:pt-64 2xl:pb-36 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-16 2xl:px-24 scroll-mt-24"
    >
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="flex flex-col gap-8 lg:col-span-7 sm:gap-10">
            <div className="text-center sm:text-left">
              <p className="section-tagline !mb-2 sm:!mb-3">{aboutSubtitle}</p>
              <h2 className="section-title !mb-3 sm:!mb-4">{aboutTitle}</h2>
              <p className="section-description">{aboutDescription}</p>
            </div>

            <div className="relative text-center sm:text-left border-l-2 border-blue-500/80 pl-5 sm:pl-6 py-1">
              <h3 className="text-xl font-extrabold text-gray-900 sm:text-2xl tracking-tight leading-tight">
                Meet Brandon Burr
              </h3>
              <p className="text-xs sm:text-sm font-bold text-blue-600 tracking-wide mt-1">
                Your Trusted Clinical Prescriber
              </p>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed mt-4">
                {staffBio}
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center lg:col-span-5">
            <div className="group relative w-full max-w-[400px] aspect-[4/5] overflow-hidden rounded-[1.75rem] shadow-[0_20px_50px_-18px_rgba(15,23,42,0.25)] bg-white">
              <img
                src="/assets/home/about/brandon-burr-480.webp"
                width={480}
                height={600}
                alt={`${staffName}, ${staffRole}`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.01]"
                loading="lazy"
                decoding="async"
              />

              <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <div className="absolute inset-0 bg-gradient-to-t from-blue-600/80 via-blue-600/10 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 flex flex-col items-center px-6 pb-6 text-center text-white">
                  <p className="text-xl font-extrabold sm:text-2xl">{staffName}</p>
                  <p className="mt-0.5 text-sm font-semibold text-blue-100 sm:text-base">
                    {staffRole}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
